import * as React from 'react';
import { useState } from 'react';
import { useRefresh, useEditContext, useListContext, useNotify, useUnselectAll, Confirm, useUpdateMany } from 'react-admin';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

const CustomUrlBulkAddButton = () => {

    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const parent = useEditContext();
    const list = useListContext();
    const notify = useNotify();
    const url = `${parent.resource}/${parent.record.guid}/${list.resource}`;

    const unselectAll = useUnselectAll(list.resource);

    const [updateMany, { isLoading }] = useUpdateMany(
        url,
        { ids: list.selectedIds, data: { } },
        {
            onSuccess: () => {
                refresh();
                unselectAll();
            },
            onError: error => notify(`Virhe lisättäessä: ${error}`, { type: 'warning' }),
        }
    );

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => {
        refresh();
        unselectAll();
        setOpen(false);
    }

    const handleConfirm = () => {
        updateMany();
        setOpen(false);
    };
    
    return (
        <>
            <Button onClick={handleClick} disabled={isLoading} color='success'><AddIcon /> Lisää</Button>
            <Confirm
                isOpen={open}
                loading={isLoading}
                title="Lisää valitut alituotteiksi"
                content={"Haluatko varmasti lisätä valitsemasi tuotteet alituotteiksi tuotteelle " + parent.record.name + "?"}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </>
    );
};

export default CustomUrlBulkAddButton;
